"use client";
import { useAuth } from "@/store/auth";
import {
  Binoculars,
  BriefcaseBusiness,
  Cable,
  CarFront,
  DollarSign,
  FileText,
  KeyRound,
  MapPin,
  Plane,
  Plug,
  Smartphone,
  User,
} from "lucide-react";
import Image from "next/image";
import { useRouter } from "next/navigation";
import { useEffect, useState } from "react";
// import 'leaflet/dist/leaflet.css';

const data = [
  {
    title: "API/XML",
    desc: "Our awesome B2B Booking Systems have API Integration that facilitates you 24/7 travel solutions for B2B cab booking.",
    icon: FileText,
  },
  {
    title: "White Label",
    desc: "We offer you to showcase your agency with our cab booking services to your customers easily and quickly.",
    icon: User,
  },
  {
    title: "Suppliers",
    desc: "With us suppliers have an opportunity to sell all inventories on our web site and also have control their pricing as per the market trends.",
    icon: BriefcaseBusiness,
  },
  {
    title: "Travel Mobile Apps",
    desc: "Mobile apps have a massive growth for travel industry so we offer our custom designed travel mobile app to you for your clients.",
    icon: Smartphone,
  },
];
const offer = [
  {
    title: "Local",
    desc: "Booking Cabs offers a hassle-free local cab booking service",
    icon: CarFront,
  },
  {
    title: "Point to Point",
    desc: "We provide B2B services to online cab service agents across India.",
    icon: MapPin,
  },
  {
    title: "Airport Transfer",
    desc: "If you are looking to scale up your online cab booking service, we would",
    icon: Plane,
  },
  {
    title: "Outstation",
    desc: "Booking Cabs can help you provide range of cab booking services.",
    icon: MapPin,
  },
  {
    title: "Self Drive",
    desc: "Booking Cabs can help you provide range of cab booking services.",
    icon: KeyRound,
  },
  {
    title: "Guide Booking",
    desc: "Booking Cabs can help you provide range of cab booking services.",
    icon: Binoculars,
  },
];
const workWithUs = [
  {
    title: "Simple",
    desc: "Booking Cabs make our cab booking search engines flexible and targeted to address each travel provider’s exact challenges. With us you can fill your gaps with our solutions according to your need.",
    icon: Plug,
  },
  {
    title: "Adjustable",
    desc: "Booking cabs offers a dedicated B2B online travel portal for API integration with direct access to our booking system and also offers our amazing online booking portal to create your customized branded frontend.",
    icon: Cable,
  },
  {
    title: "Profitable",
    desc: "Booking Cabs has vast experience in the industry and understand everything in a better way when you are starting a business. So don’t worry, we don’t take initial fees from you! We make charges on first customer!",
    icon: DollarSign,
  },
];

const designedForEveryone = [
  {
    title: "Travel Manager",
    desc: "Who manages company's travel expense",
    data: [
      "Simplified Admin Panel to manage all employees and their expenses",
      "Detailed reports on regular basis to keep a track on your spends",
      "Dedicated Support Manager from myBiz to take care of your queries",
    ],
  },
  {
    title: "Central Bookers",
    desc: "Who books for employees",
    data: [
      "Book using the traveller's Policy to ensure the right options are booked",
      "Shortlist & share travel options to employees directly from myBiz",
      "Track your requests & get the job done from one single place",
    ],
  },
  {
    title: "Employees",
    desc: "Who travel for business",
    data: [
      "Special Corporate Fares in flights to ensure you get more benefits at reduced price",
      "myBiz Assured Hotels for top-rated stay options",
      "Sanitized Cabs to safely pick & drop you to your destinations",
    ],
  },
];


const statistics = [
  {
    value: "170+",
    title: "Countries",
  },
  {
    value: "18000+",
    title: "Locations"
  },
  {
    value: "80%",
    title: "Booking Increment"
  },
  {
    value: "250+",
    title: "Suppliers"
  }
]

export default function Home() {
  const [scrolled, setScrolled] = useState(false);
  const router = useRouter();

  useEffect(() => {
    const onScroll = () => {
      setScrolled(window.scrollY > 10);
    };
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div className="min-h-screen">
      <div className="relative flex overflow-hidden h-[550px] lg:h-[600px]">
        <div
          className="absolute inset-0 bg-center bg-no-repeat bg-cover bg-fixed"
          style={{ backgroundImage: "url('/images/slider/bg3.jpg')" }}
        />

        <div className="absolute inset-0 bg-black/40 z-10" />

        <div className="relative z-20 w-full">
          <header
            className={`fixed top-[0px] z-30 w-full flex items-center justify-between h-[60px] px-10 z-50 transition-colors duration-300 ${
              scrolled ? "bg-white shadow-md" : "bg-white/70 backdrop-blur-sm"
            }`}
          >
            <div>
              <Image
                src="/images/logo.png"
                alt="Logo"
                width={180}
                height={60}
                className="w-[120px] h-[30px] lg:w-[160px] lg:h-[45px]"
                priority
              />
            </div>

            <div className="flex items-center gap-2">
              <button
                onClick={() => router.push("/signup")}
                className="text-white bg-[#FF9F00] cursor-pointer p-2 rounded-sm font-[500] text-[13px]"
              >
                Register with us
              </button>
              <button
                onClick={() => router.push("/login")}
                className="text-white bg-[#CB2325] cursor-pointer p-2 rounded-sm font-[500] text-[13px]"
              >
                Affiliate/Suppliers Login
              </button>
            </div>
          </header>
          <div className="flex flex-col my-20 py-30 h-full px-5 sm:px-20">
            <h1 className="font-[700] mb-5 select-none text-2xl md:text-3xl">
              <span className="text-gray-900 opacity-60">Book</span>
              <span className="text-[#FF9F00]">ing</span>
              <span className="text-red-800">Cabs</span>
              <span className="text-gray-900 opacity-60">.com</span>
              <span className="text-gray-200"> for Business</span>
            </h1>

            <h1 className="text-white font-bold text-4xl md:text-5xl">
              Transport booking solutions
            </h1>
            <h1 className="text-white font-bold text-4xl md:text-5xl">
              tailor-made to boost your revenue
            </h1>

            <button className="w-[max-content] cursor-pointer my-10 py-3 bg-[#FF9F00] rounded-sm text-white text-md font-semibold px-4 md:px-8 md:text-lg">
              Get Started
            </button>
          </div>
        </div>
      </div>

      <div className="grid grid-cols-2 gap-3 p-8 px-8 md:grid-cols-4 md:px-20">
        {data.map(({ title, desc, icon: Icon },index) => (
          <div
            className="flex flex-col items-center justify-center"
            key={index}
          >
            <div className="border-4 border-gray-300 p-1 rounded-full shadow-sm cursor-pointer">
              <div className="rounded-full p-5 border-4 border-[#042149]">
                <Icon className="w-10 h-10 text-[#042149]" />
              </div>
            </div>

            <h1 className="text-xl mt-4 font-[600] text-gray-600 mb-1 cursor-pointer">
              {title}
            </h1>
            <p className="text-[12px] text-center text-gray-500">{desc}</p>
          </div>
        ))}
      </div>


      <div className="designed-for-everyone bg-gray-100 py-7 px-6">
        <h1 className="font-bold  text-gray-600 mb-1 px-6 text-3xl sm:text-4xl">
          Designed for Everyone in
        </h1>
        <h1 className="font-bold text-gray-600 mb-3 px-6 text-3xl sm:text-4xl">
          the Organisation
        </h1>

        <h1 className="font-[500] text-gray-500 px-6 text-md sm:text-xl">
          Our features and benefits are curated to suit the needs of{" "}
        </h1>
        <h1 className="font-[500] text-gray-500 px-6 text-md sm:text-xl">
          every employee using BookingCabs.com
        </h1>

        <div className="grid grid-cols-1 items-center gap-5 my-6 sm:grid-cols-3 md:px-6">
          {designedForEveryone.map(({ title, desc, data },index) => (
            <div key={index} className="bg-white shadow-lg rounded-md py-6 h-full relative px-3 md:px-6">
              <h1 className="font-semibold text-gray-700 text-xl md:text-2xl">{title}</h1>
              <h1 className="text-gray-500 mb-3 text-[12px] md:text-sm">{desc}</h1>
              <ul className="space-y-2 list-disc px-5 py-4 text-gray-600 mb-7 text-[12px] md:text-sm">
                {data.map((item,indx) => (
                  <li key={indx}>{item}</li>
                ))}
              </ul>

              <span className="uppercase font-[500] absolute bottom-[20px] left-1/2 translate-x-[-50%] text-gray-800 cursor-pointer hover:underline text-sm md:text-base">
                Know More
              </span>
            </div>
          ))}
        </div>
      </div>

      {/* Work with Us */}
      <div className="py-2 my-8 px-8 md:px-20">
        <h1 className="text-center text-3xl mt-4 font-[600] text-gray-600 mt-4 mb-7">
          Why Work with us
        </h1>
        <div className="grid gap-2 grid-cols-1 sm:grid-cols-3">
          {workWithUs.map(({ title, desc, icon: Icon }) => (
            <div
              className="flex flex-col items-center justify-center cursor-pointer"
              key={title}
            >
              <div className="p-1 rounded-full border-4">
                <div className="rounded-full p-4">
                  <Icon className="w-10 h-10 text-black" />
                </div>
              </div>

              <h1 className="text-xl mt-4 font-[500] text-gray-700 mb-1">
                {title}
              </h1>
              <p className="text-[12px] text-center text-gray-600">{desc}</p>
            </div>
          ))}
        </div>
      </div>

      <div className="download bg-gray-100 my-5 py-7 px-6 flex items-center justify-between flex-col gap-6 md:flex-row">
        <div className="w-full md:w-[50%] flex items-center justify-center relative">


          <div className="w-[250px] h-[250px] bg-[#CB2325] rounded-full absolute border-2 border-red-600 m-2"></div>

          <div className="w-[290px] h-[290px] bg-transparent rounded-full absolute border-8 border-[#CB2325] m-2"></div>



          <Image
            src="/images/mobile_view.png"
            alt="Logo"
            width={210}
            height={400}
            className="z-20"
            priority
          />
        </div>

        <div className="flex flex-col gap-3 w-full md:w-[50%]">
          <h1 className="font-bold text-3xl md:text-4xl">
            Seamless Access from Everywhere
          </h1>
          <h2 className="font-[500] text-gray-600 text-base md:text-xl">
            With our super intuitive and connected web application & mobile app,
            myBiz is always available to address all your business travel needs.
          </h2>

          <h3 className="font-bold text-base md:text-lg">
            Scan QR code to download BookingCabs.com app
          </h3>

          <div className="flex items-center gap-20">
            <Image
              src="/images/app-qr.png"
              alt="Logo"
              width={200}
              height={190}
              priority
              className="w-[150px] h-[140px] md:w-[200px] md:h-[190px]"
            />

            <Image
              src="/images/google-play-cion.png"
              alt="Logo"
              width={140}
              height={160}
              priority
              className="w-[120px] h-[60px] md:w-[200px] md:h-[100px] cursor-pointer"
            />
          </div>
        </div>
      </div>

        <div className="statistics grid items-center justify-evenly w-[95%] gap-12 mx-auto my-6 grid-cols-2 md:grid-cols-4">
        {
          statistics.map(({title,value}) => (
            <div key={title} className="h-[160px] bg-gray-100 shadow-md w-full flex flex-col px-10 justify-center border border-gray-100 relative gap-2">
              <div className="h-[90px] w-[8px] bg-[#CB2325] absolute left-0 top-0"></div>
              <div className="text-4xl font-semibold text-gray-700">
                {value}
              </div>
              <h1 className="text-md font-[500] text-gray-600">{title}</h1>
            </div>
          ))
        }
      </div>
    </div>
  );
}
